import { render, staticRenderFns } from "./g-assistant-production-history-card.vue?vue&type=template&id=3023c8b7&scoped=true&"
import script from "./g-assistant-production-history-card.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-assistant-production-history-card.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-assistant-production-history-card.vue?vue&type=style&index=0&id=3023c8b7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023c8b7",
  null
  
)

export default component.exports